import { apiClient, HttpError } from '@littlebird/auth-client';

const PERSONAL_EMAIL_DOMAINS = new Set([
  'gmail.com',
  'yahoo.com',
  'outlook.com',
  'hotmail.com',
  'icloud.com',
  'protonmail.com',
  'aol.com',
  'live.com',
  'msn.com',
]);

export async function lookupSsoConnection(
  email: string
): Promise<string | null> {
  const domain = email.slice(email.lastIndexOf('@') + 1).toLowerCase();
  if (PERSONAL_EMAIL_DOMAINS.has(domain)) return null;
  return apiClient
    .post<{ connection: string | null }>(
      '/team/sso/lookup',
      { email },
      {
        skipAuth: true,
        signal: AbortSignal.timeout(3_000),
        retryOptions: { retries: 0 },
      }
    )
    .then(({ connection }) => connection)
    .catch(() => null);
}

export function isSsoRequiredError(error: unknown): boolean {
  return (
    error instanceof HttpError && error.body?.detail?.code === 'sso_required'
  );
}
